import { motion } from 'framer-motion';
import { ArrowRight, Download } from 'lucide-react';
import { HERO_RENDER, PROPERTY, PDF_URL, openViewing } from './data';

const rise = (delay) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 1.1, delay, ease: [0.22, 1, 0.36, 1] },
});

export const HeroSection = () => (
  <section id="home" className="relative min-h-[92vh] flex items-end" data-testid="hero-section">
    <div className="absolute inset-0 z-0">
      <img src={HERO_RENDER} alt="The 126 House" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1a1e1a] via-black/45 to-black/40" />
      <span className="absolute top-24 right-6 md:right-12 text-white/80 text-[11px] tracking-[0.12em] uppercase">Architectural render</span>
    </div>

    <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 pb-16 md:pb-24">
      <motion.p {...rise(0.2)} className="text-[#d6cdb4] text-sm md:text-base tracking-[0.2em] uppercase mb-5" data-testid="hero-locality">
        {PROPERTY.locality}
      </motion.p>
      <motion.h1 {...rise(0.35)} className="text-5xl sm:text-6xl lg:text-8xl text-white font-light tracking-tight leading-[0.95] mb-6" data-testid="hero-title">
        {PROPERTY.name}
      </motion.h1>
      <motion.p {...rise(0.5)} className="text-white/85 text-sm md:text-base mb-6" data-testid="hero-address">
        {PROPERTY.address}, {PROPERTY.locality}
      </motion.p>
      <motion.p {...rise(0.65)} className="text-white/85 text-lg md:text-xl leading-relaxed max-w-2xl mb-10">
        An architectural coastal home in a gated sanctuary, minutes from Mangawhai's surf beach
        and the region's celebrated golf courses.
      </motion.p>
      <motion.div {...rise(0.8)} className="flex flex-col sm:flex-row gap-4">
        <button
          type="button"
          onClick={() => openViewing('viewing')}
          data-testid="hero-viewing-btn"
          className="group inline-flex items-center justify-center gap-3 bg-[#c8bfa8] text-[#1a1e1a] px-8 py-4 text-sm tracking-[0.12em] uppercase font-medium hover:bg-white transition-colors"
        >
          Arrange a private viewing
          <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
        </button>
        <a
          href={PDF_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="hero-brochure-btn"
          className="inline-flex items-center justify-center gap-3 border border-white/50 text-white px-8 py-4 text-sm tracking-[0.12em] uppercase hover:bg-white/10 transition-colors"
        >
          <Download size={16} />
          Brochure
        </a>
      </motion.div>
    </div>
  </section>
);
